module.exports = __webpack_public_path__ + "static/media/dashboard-bg.3a3d7372.svg";